import React from 'react';
import styled from 'styled-components';

import success from './images/icon-success-white.svg';
import error from './images/icon-error-white.svg';

const Validation = styled.div`
  @keyframes animation-hide {
  	0% {
  		opacity: 1;
  		transform: translate3d(0, 0, 0);
  		animation-delay: 3s;
  		display: flex;
  	}
  	
  	100% {
  		opacity: 0;
  		transform: translate3d(0, -20px, 0);
  		animation-delay: 3s;
		position: absolute;
		visibility: hidden;
  	}
  }

  font-family: Poppins, Heltica, Arial, sans-serif;
  font-size: 1.4em;
  width: 100%;
  margin: 0;
  padding: 15px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  animation: 1s animation-hide forwards;
  animation-delay: 10s;
  
  &.alert {
    border-radius: 4px;
  }
  
  &.alert.success {
    background-color: #00D8A8;
  }
  
  &.alert.error {
    background-color: #F53D5F;
  }
`;

const AlertStatus = (props) => {
	const { message, status } = props;

	return (
		<Validation className={`alert ${status}`}>
			<img src={status === 'success' ? success : error} width={30} alt={`ícone de ${status}`} className="mr-2" />

			<p className="m-0">{message}</p>
		</Validation>
	);
};

export default AlertStatus;
